import { gql } from "@apollo/client";

export const createTag = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      id
      userId
      tag
      createdAt
      updatedAt
    }
  }
`;

export const createTransfer = gql`
  mutation CreateTransfer($input: PaymentInput!) {
    createTransfer(input: $input) {
      message
      status
      transfer {
        id
        balance
        recepientTag
        amount
      }
    }
  }
`;

export const confirmTransfer = gql`
  mutation ConfirmTransfer($otp: String!) {
    confirmTransfer(otp: $otp) {
      message
      status
      transfer {
        id
        balance
        recepientTag
        amount
      }
    }
  }
`;

export const saveBeneficiary = gql`
  mutation RemoveOrAddBeneficiary($options: BeneficiaryOptionsInput!) {
    removeOrAddBeneficiary(options: $options)
  }
`;

export const createBankTransfer = gql`
  mutation CreateBankTransfer($input: BankPaymentInput!) {
    createBankTransfer(input: $input) {
      message
      status
    }
  }
`;

export const createWireTransfer = gql`
  mutation CreateWireTransfer($accountTransfer: CreateWireTransferInput) {
    createWireTransfer(accountTransfer: $accountTransfer) {
      message
      status
    }
  }
`;

export const ConfirmFundTransfer = gql`
  mutation ConfirmFundTransfer($otp: String!) {
    confirmFundTransfer(otp: $otp) {
      message
      status
    }
  }
`;

export const CreateDirectTransfer = gql`
  mutation CreateDirectTransfer($accountTransfer: CreateDirectTransferInput) {
    createDirectTransfer(accountTransfer: $accountTransfer) {
      message
      status
    }
  }
`;
